import {ResponseBase} from "../../data";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {
    ControlCommands, ControlData, PodEvents,
    PodMetrics, EnapKepEvents,
    InverterDataGrid,
    MeterDataGrid,
    MeterInverterData,
    PodDeviceData,
    PodEnergyBalance, RatedPower
} from "../../data/podDetail";

const emptyPodEfeData: PodDeviceData = {
    podId: "",
    customerName: "",
    systemId: "",
    phaseCount: 0,
    address: "",
    longitude: 0,
    latitude: 0,
    dteDeviceTypeTag: "",
    dte3phaseDevice: false,
    dmaName: "",
    pfaName: "",
    dteTemplateName: "",
    dtePicture: "",
    hwtVersion: "",
    activeFirmwareVersionName: "",
};

export interface PodDetailState {
    response: ResponseBase | null;
    isLoading: boolean;
    error: ResponseBase | null;
    podEfeData: PodDeviceData;
    meterInverterDataList: MeterInverterData[];
    podEnergyBalance: PodEnergyBalance;
    podMetrics: PodMetrics;
    meterDataGrid: MeterDataGrid;
    inverterDataGrid: InverterDataGrid;
    controlCommandsList: ControlCommands[];
    enapKepEventsList: EnapKepEvents[];
    podEventsList: PodEvents[];
    controlData: ControlData;
    metricsLoading: boolean;
    ratedPower: RatedPower;
}

const initialState: PodDetailState = {
    response: null,
    isLoading: false,
    error: null,
    podEfeData: emptyPodEfeData,
    meterInverterDataList: [],
    podEnergyBalance: {} as PodEnergyBalance,
    podMetrics: {} as PodMetrics,
    meterDataGrid: {} as MeterDataGrid,
    inverterDataGrid: {} as InverterDataGrid,
    controlCommandsList: [],
    enapKepEventsList: [],
    podEventsList: [],
    controlData: {} as ControlData,
    metricsLoading: false,
    ratedPower: {} as RatedPower,
};

const podDetailSlice = createSlice({
    name: "podDetailSlice",
    initialState: initialState,
    reducers: {
        setResponse(state, action: PayloadAction<ResponseBase | null>) {
            state.response = action.payload;
            state.isLoading = false;
        },
        setLoading(state, action: PayloadAction<boolean>) {
            state.isLoading = action.payload;
        },
        setMetricsLoading(state, action: PayloadAction<boolean>) {
            state.metricsLoading = action.payload;
        },
        setError(state, action: PayloadAction<ResponseBase | null>) {
            state.isLoading = false;
            state.error = action.payload;
        },
        setPodEfeData(state, action: PayloadAction<PodDeviceData>) {
            state.podEfeData = action.payload ?? emptyPodEfeData;
            state.isLoading = false;
        },
        setMeterInverterDataList(state, action: PayloadAction<MeterInverterData[]>) {
            state.meterInverterDataList = action.payload;
            state.isLoading = false;
        },
        setPodEnergyBalance(state, action: PayloadAction<PodEnergyBalance>) {
            state.podEnergyBalance = action.payload;
            state.isLoading = false;
        },
        setPodMetrics(state, action: PayloadAction<PodMetrics>) {
            state.podMetrics = action.payload;
            state.isLoading = false;
            state.metricsLoading = false;
        },
        setMeterDataGrid(state, action: PayloadAction<MeterDataGrid>) {
            state.meterDataGrid = action.payload;
            state.isLoading = false;
        },
        setInverterDataGrid(state, action: PayloadAction<InverterDataGrid>) {
            state.inverterDataGrid = action.payload;
            state.isLoading = false;
        },
        setControlCommandsList(state, action: PayloadAction<ControlCommands[]>) {
            state.controlCommandsList = action.payload;
            state.isLoading = false;
        },
        setEnapKepEventsList(state, action: PayloadAction<EnapKepEvents[]>) {
            state.enapKepEventsList = action.payload;
            state.isLoading = false;
        },
        setPodEventsList(state, action: PayloadAction<PodEvents[]>) {
            state.podEventsList = action.payload;
            state.isLoading = false;
        },
        setControlData(state, action: PayloadAction<ControlData>) {
            state.controlData = action.payload;
            state.isLoading = false;
        },
        setRatedPower(state, action: PayloadAction<RatedPower>) {
            state.ratedPower = action.payload;
            state.isLoading = false;
        },
    }
});

export const podDetailActions = podDetailSlice.actions;
export default podDetailSlice;
